import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Typography from '@material-ui/core/Typography';
import Train from '@material-ui/icons/Train';

import GridItem from 'components/Grid/GridItem.jsx';
import Card from 'components/Card/Card.jsx';
import CardBody from 'components/Card/CardBody.jsx';
import CardHeader from 'components/Card/CardHeader.jsx';
import CardIcon from 'components/Card/CardIcon.jsx';
import { Query } from 'react-apollo';
import { getBlsOrdersByUserId } from '../../bls/schema/bls-schema.graphql';
import BlsOverviewTable from '../../bls/components/BlsOverviewTable';

class BlsUserOrders extends Component {
  render() {
    const { onOrderSelect, userId } = this.props;
    return (
      <GridItem xs={12} sm={12} md={10} lg={6}>
        <Card>
          <CardHeader color="rose" icon>
            <CardIcon color="info">
              <Train />
            </CardIcon>
          </CardHeader>
          <CardBody>
            <Typography variant="headline" color="textSecondary">
              BLS Bestellungen
            </Typography>
            <Query query={getBlsOrdersByUserId} variables={{ userId }}>
              {({ data }) => (
                <BlsOverviewTable
                  orders={data.orders}
                  onOrderClick={onOrderSelect}
                  showUser={false}
                />
              )}
            </Query>
          </CardBody>
        </Card>
      </GridItem>
    );
  }
}

BlsUserOrders.propTypes = {
  userId: PropTypes.string.isRequired,
  onOrderSelect: PropTypes.func.isRequired,
};

export default BlsUserOrders;



// WEBPACK FOOTER //
// ./src/views/users/components/BlsUserOrders.jsx